<div class="request-container">
	<div
		class="request-card-wrapper"
		[@scalePassCards]="scaleCardTrigger$ | async"
		#cardWrapper
		[style.background-image]="gradient"
		[style.height]="forStaff ? (isModal ? '400px' : '451px') : '412px'"
		ondragstart="return false">
		<div class="pass-card-header">
			<div class="header-content">
				<div class="header-info">
					<img class="pass-card-header-icon" [src]="request.icon | resolveAsset" />
					<div class="pass-card-header-text">
						{{ request.destination.title }}
						<div class="card-subtitle" *ngIf="fromPast || forFuture">
							<span notranslate *ngIf="request.request_time && forFuture; else forNow">
								{{ formatDateTime(request.request_time) }}
							</span>
							<ng-template #forNow>
								<span>{{ forStaff ? 'Pass For Now' : '' }}</span>
							</ng-template>
						</div>
					</div>
				</div>

				<div [ngClass]="iconClass">
					<app-icon-button
						*ngIf="!activeTeacherPin"
						[srcString]="
							'./assets/' +
							(!forStaff && !forInput && !invalidDate ? 'Delete' : !forInput && (forStaff || invalidDate) ? 'Dots' : 'Chevron Left') +
							' (Transparent).svg'
						"
						[onDarkShade]="true"
						[size]="20"
						(clickEvent)="cancelRequest($event)"></app-icon-button>
					<app-icon-button
						*ngIf="activeTeacherPin"
						[srcString]="'./assets/Chevron Left (White).svg'"
						[onDarkShade]="true"
						[size]="20"
						(clickEvent)="activeTeacherPin = false"></app-icon-button>
				</div>
			</div>

			<mat-divider></mat-divider>
		</div>

		<div class="request-card-content" *ngIf="!isModal && !kioskModeRestricted">
			<div class="duration-picker">
				<app-traveltype-picker
					[width]="request.destination.travel_types.length < 2 ? '106px' : '185px'"
					[height]="'28px'"
					(onSelect)="selectedTravelType = $event"
					[choices]="request.destination.travel_types"
					[altColor]="request.color_profile.solid_color"></app-traveltype-picker>
				<app-duration-picker
					*ngIf="forInput"
					(onChange)="selectedDuration = $event"
					[maxDuration]="request.destination.max_allowed_time ? request.destination.max_allowed_time : 15"></app-duration-picker>
			</div>
			<div class="button">
				<app-card-button
					(onClick)="newRequest()"
					[disabled]="performingAction"
					[width]="'269px'"
					[height]="'79px'"
					[gradientColor]="request.color_profile.gradient_color">
					<div class="request-button-content">
						<mat-spinner *ngIf="performingAction" [color]="'accent'" [diameter]="35"></mat-spinner>
						<div *ngIf="!performingAction" class="request-pass-content-text">Send Request</div>
						<img *ngIf="!performingAction" class="button-icon-right" [src]="'./assets/SP Arrow (White).svg' | resolveAsset" />
					</div>
				</app-card-button>
			</div>
		</div>

		<div class="request-card-content-modal" *ngIf="isModal || kioskModeRestricted">
			<div class="student-view" [@.disabled]="activeTeacherPin" *ngIf="!forStaff">
				<div class="content-container" *ngIf="!activeTeacherPin; else teacherPin">
					<div class="center-block">
						<app-pager *ngIf="!forInput" [arrowPosition]="'-93px'" [isStaff]="false">
							<div class="page-1" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<app-duration-picker
									*ngIf="forInput"
									(onChange)="selectedDuration = $event"
									[maxDuration]="request.destination.max_allowed_time ? request.destination.max_allowed_time : 15"></app-duration-picker>
								<app-travel-view *ngIf="!forInput" [pass]="request" [shrink]="true"></app-travel-view>
							</div>
							<div class="page-2" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<div class="page-2-wrapper">
									<div [ngClass]="isIOSTablet ? 'ios-margin-left' : ''" class="message" [style.height]="forInput ? '70px' : '155px'">
										<span [style.font-weight]="'bold'">{{ forStaff ? 'Message from ' + studentName + ':' : 'Your message:' }}</span
										><br />
										<span style="user-select: text">{{ request.attachment_message === '' ? 'No message' : request.attachment_message }}</span>
										<div *ngIf="request.status === 'declined'">
											<br />
											<span [style.font-weight]="'bold'" ignore>Message from {{ request.teachers[0].last_name }}:</span><br />
											<span style="user-select: text">{{ request.declined_message === '' ? 'No message' : request.declined_message }}</span>
											<!-- deny_message -->
										</div>
									</div>
									<app-card-button
										*ngIf="forInput"
										(onClick)="editMessage()"
										class="edit-button"
										[width]="'110px'"
										[height]="'35px'"
										[gradientColor]="request.color_profile.gradient_color">
										<div class="button-content">Edit Message</div>
									</app-card-button>
								</div>
							</div>

							<div class="page-5" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<app-duration-picker
									*ngIf="forInput; else noInput"
									(onChange)="selectedDuration = $event"
									[maxDuration]="request.destination.max_allowed_time ? request.destination.max_allowed_time : 15"></app-duration-picker>
								<ng-template #noInput>
									<app-travel-view *ngIf="!screenService.isDeviceLargeExtra" [pass]="request" [shrink]="true"></app-travel-view>
									<app-travel-view *ngIf="screenService.isDeviceLargeExtra" [height]="'164px'" [pass]="request" [shrink]="true"></app-travel-view>
								</ng-template>
							</div>

							<div class="page-6" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<div class="page-2-wrapper">
									<div [ngClass]="isIOSTablet ? 'ios-margin-left' : ''" class="message" [style.height]="forInput ? '70px' : '155px'">
										<span [style.font-weight]="'bold'">{{ forStaff ? 'Message from ' + studentName + ':' : 'Your message:' }}</span
										><br />
										<span style="user-select: text">{{ request.attachment_message === '' ? 'No message' : request.attachment_message }}</span>
										<div *ngIf="request.status === 'declined'">
											<br />
											<span [style.font-weight]="'bold'" ignore>Message from {{ request.teachers[0].last_name }}:</span><br />
											<span style="user-select: text">{{ request.declined_message === '' ? 'No message' : request.declined_message }}</span>
											<!-- deny_message -->
										</div>
									</div>
									<app-card-button
										*ngIf="forInput"
										(onClick)="editMessage()"
										class="edit-button"
										[width]="'110px'"
										[height]="'35px'"
										[gradientColor]="request.color_profile.gradient_color">
										<div class="button-content">Edit Message</div>
									</app-card-button>
								</div>
							</div>
						</app-pager>
					</div>

					<mat-divider
						*ngIf="
							((request.status === 'accepted' || invalidDate) && !forInput && !forStaff) || (request.status !== 'pending' && forStaff)
						"></mat-divider>

					<div class="bottom-block">
						<div
							*ngIf="request.status === 'pending' && !invalidDate; else noTeachPin"
							(mouseenter)="onHover(desc, title)"
							(mouseleave)="onLeave(desc)">
							<app-card-button [width]="'297px'" [height]="'81px'" [gradientColor]="request.color_profile.gradient_color" (onClick)="goToPin()">
								<div class="resend-button-content">
									<div class="center-content">
										<div class="resend-button-content-title" style="display: flex; align-items: center">
											<img style="margin-right: 10px" width="18" height="18" [src]="'./assets/Lock dots (White).svg' | resolveAsset" alt="Lock" />
											Enter Teacher Pin
										</div>
										<div class="description-container" #title>
											<div
												class="shadow left-radius"
												[ngStyle]="{ 'box-shadow': '0px 0px 17px 10px ' + solidColorRgba2 }"
												[style.background]="request.gradient_color.split(',')[1]"
												[style.left]="0"
												*ngIf="leftTextShadow"></div>
											<div class="description-title" #desc [style.margin-left]="filteredTeachers.length > 1 ? '0px' : '15px'">
												Pass Request sent to:
												<span style="width: 5px"></span>
												<span notranslate style="font-weight: normal; font-size: 17px" *ngFor="let teacher of filteredTeachers; let i = index">
													<span style="margin-right: 3px">{{ teacher.display_name + (i === filteredTeachers.length - 1 ? '' : ', ') }}</span>
												</span>
											</div>
											<div
												class="shadow right-radius"
												[ngStyle]="{ 'box-shadow': '0px 0px 30px 20px ' + solidColorRgba }"
												[style.background]="request.gradient_color.split(',')[0]"
												*ngIf="!removeShadow"
												[style.right]="0"></div>
										</div>
									</div>
								</div>
							</app-card-button>
						</div>
						<ng-template #noTeachPin>
							<div *ngIf="isKioskMode && request.status === 'declined'; else teacherView">
								<app-card-button
									*ngIf="!forStaff"
									[disabled]="performingAction"
									(onClick)="resendRequest()"
									[width]="'297px'"
									[height]="'81px'"
									[gradientColor]="request.color_profile.gradient_color">
									<div class="resend-button-content">
										<mat-spinner *ngIf="performingAction" [color]="'accent'" [diameter]="35"></mat-spinner>
										<div *ngIf="!performingAction" class="resend-button-content-title">{{ forFuture ? 'Change Date & Time' : 'Resend Request' }}</div>
										<div class="resend-button-content-subtitle">Pass Request Denied</div>
									</div>
								</app-card-button>
							</div>

							<ng-template #teacherView>
								<div class="request-description">
									<img class="request-description-icon" [src]="'./assets/Lock (White).svg' | resolveAsset" />
									<div class="request-description-text">
										Pass Request sent to: <br />
										<span style="font-weight: normal; font-size: 17px" notranslate *ngFor="let teacher of filteredTeachers; let i = index">
											{{ teacher.display_name + (i === filteredTeachers.length - 1 ? '' : ', ') }}
										</span>
									</div>
								</div>
							</ng-template>
						</ng-template>
						<div *ngIf="request.status === 'accepted'">
							<div class="request-description">
								<img class="request-description-icon" [src]="'./assets/Arrow (White).svg' | resolveAsset" />
								<div class="request-description-text" ignore>Pass Request accepted by {{ request.teachers[0].last_name }}</div>
							</div>
						</div>
					</div>
				</div>

				<ng-template #teacherPin>
					<div class="teacher-pin">
						<app-teacher-pin-student (pinResult)="handlePinResult($event)" [request]="request" [requestId]="request.id"></app-teacher-pin-student>
					</div>
				</ng-template>
			</div>

			<div class="teacher-view" *ngIf="forStaff">
				<div class="pager" style="height: 210px">
					<app-pager *ngIf="!forInput" [arrowPosition]="'-93px'" [isStaff]="true">
						<div class="page-1" [attr.data-motion-translate]="(frameMotion$ | async).direction">
							<app-duration-picker
								*ngIf="forInput; else noInput"
								(onChange)="selectedDuration = $event"
								[maxDuration]="request.destination.max_allowed_time ? request.destination.max_allowed_time : 15"></app-duration-picker>
							<ng-template #noInput>
								<app-travel-view [height]="'164px'" [pass]="request" [shrink]="true"></app-travel-view>
							</ng-template>
						</div>
						<div class="page-2" [attr.data-motion-translate]="(frameMotion$ | async).direction">
							<div class="page-2-wrapper">
								<div [ngClass]="isIOSTablet ? 'ios-margin-left' : ''" class="message" [style.height]="forInput ? '70px' : '164px'">
									<span [style.font-weight]="'bold'">{{ forStaff ? 'Message from ' + studentName + ':' : 'Your message:' }}</span
									><br />
									<span style="user-select: text">{{ request.attachment_message === '' ? 'No message' : request.attachment_message }}</span>
									<div *ngIf="request.status === 'declined'">
										<br />
										<span [style.font-weight]="'bold'" ignore>Message from {{ request.teachers[0].last_name }}:</span><br />
										<span style="user-select: text">{{ request.declined_message === '' ? 'No message' : request.declined_message }}</span>
										<!-- deny_message -->
									</div>
								</div>
								<app-card-button
									*ngIf="forInput"
									(onClick)="editMessage()"
									class="edit-button"
									[width]="'110px'"
									[height]="'35px'"
									[gradientColor]="request.color_profile.gradient_color">
									<div class="button-content">Edit Message</div>
								</app-card-button>
							</div>
						</div>

						<div class="page-5" [attr.data-motion-translate]="(frameMotion$ | async).direction">
							<app-duration-picker
								*ngIf="forInput; else noInput"
								(onChange)="selectedDuration = $event"
								[maxDuration]="request.destination.max_allowed_time ? request.destination.max_allowed_time : 15"></app-duration-picker>
							<ng-template #noInput>
								<app-travel-view [height]="'164px'" [pass]="request" [shrink]="true"></app-travel-view>
							</ng-template>
						</div>

						<div class="page-6" [attr.data-motion-translate]="(frameMotion$ | async).direction">
							<div class="page-2-wrapper">
								<div [ngClass]="isIOSTablet ? 'ios-margin-left' : ''" class="message" [style.height]="forInput ? '70px' : '164px'">
									<span [style.font-weight]="'bold'">{{ forStaff ? 'Message from ' + studentName + ':' : 'Your message:' }}</span
									><br />
									<span style="user-select: text">{{ request.attachment_message === '' ? 'No message' : request.attachment_message }}</span>
									<div *ngIf="request.status === 'declined'">
										<br />
										<span [style.font-weight]="'bold'" ignore>Message from {{ request.teachers[0].last_name }}:</span><br />
										<span style="user-select: text">{{ request.declined_message === '' ? 'No message' : request.declined_message }}</span>
										<!-- deny_message -->
									</div>
								</div>
								<app-card-button
									*ngIf="forInput"
									(onClick)="editMessage()"
									class="edit-button"
									[width]="'110px'"
									[height]="'35px'"
									[gradientColor]="request.color_profile.gradient_color">
									<div class="button-content">Edit Message</div>
								</app-card-button>
							</div>
						</div>
					</app-pager>
				</div>
				<div *ngIf="forInput; else staffNoInput">Something went wrong</div>
				<ng-template #staffNoInput>
					<div *ngIf="request.status == 'pending'; else staffNotPending" style="margin-bottom: 12px; width: 295px">
						<app-card-button
							(onClick)="approveRequest()"
							*ngIf="!invalidDate; else CDate"
							[disabled]="performingAction"
							[width]="'295px'"
							[height]="'81px'"
							[gradientColor]="request.color_profile.gradient_color">
							<div class="resend-button-content">
								<mat-spinner *ngIf="performingAction" [color]="'accent'" [diameter]="35"></mat-spinner>
								<div *ngIf="!performingAction" class="resend-button-content-title">Approve Pass Request</div>
								<div class="resend-button-content-subtitle">
									<span notranslate>{{ request.duration / 60 }}</span>
									<span> min - Received </span>
									<span notranslate>{{ formatDateTime(request.created, true) }}</span>
								</div>
							</div>
						</app-card-button>
						<ng-template #CDate>
							<app-card-button [width]="'295px'" [height]="'81px'" (onClick)="changeDate()" [gradientColor]="request.color_profile.gradient_color">
								<div class="resend-button-content">
									<div class="resend-button-content-title">Change Date & Time</div>
									<div class="resend-button-content-subtitle">Resend Pass Request to Student</div>
								</div>
							</app-card-button>
						</ng-template>
					</div>
					<ng-template #staffNotPending>
						<div>
							<app-pager [page]="2">
								<div class="page-1 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
									<span class="bold">Pass Request Sent</span
									><span class="smaller"
										><br />to <var>{{ studentName }}</var
										><br /><br /><var>{{ formatDateTime(request.created) }}</var></span
									>
								</div>
								<div class="page-2 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
									<span class="bold">Pass Request {{ status }}</span
									><span class="smaller"
										><br />by <var>{{ teacherName }}</var
										><br /><br /><var>{{ formatDateTime(request.last_updated) }}</var></span
									>
								</div>

								<div class="page-5 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
									<span class="bold">Pass Request Sent</span
									><span class="smaller"
										><br />to <var>{{ studentName }}</var
										><br /><br /><var>{{ formatDateTime(request.created) }}</var></span
									>
								</div>
								<div class="page-6 teacher-details" [attr.data-motion-translate]="(frameMotion$ | async).direction">
									<span class="bold">Pass Request {{ status }}</span
									><span class="smaller"
										><br />by <var>{{ teacherName }}</var
										><br /><br /><var>{{ formatDateTime(request.last_updated) }}</var></span
									>
								</div>
							</app-pager>
						</div>
					</ng-template>
				</ng-template>
			</div>

			<div class="request-card-footer" *ngIf="forStaff && !isModal">
				<div class="student-footer"></div>
				<div class="student-text" notranslate>{{ request.student.display_name }}</div>
			</div>
		</div>
	</div>

	<div
		class="student-footer-info"
		*ngIf="(forStaff && isModal) || (formState && formState.kioskMode && request.id !== null && request.status !== 'declined')"
		[style.marginTop]="forStaff ? '64px' : '20px'">
		<app-student-passes [pass]="request" [profile]="request.student"></app-student-passes>
	</div>
</div>

<ng-template #PassLimitOverride>
	<div class="ds-dialog-normal-text">
		<span>If it's an emergency, you can override the limit.</span>
	</div>
</ng-template>
